<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30" id="ShippingFeeList">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
          	<th class="wd-lg-300">{{$t("express.地址名称")}}</th>
          	<th class="wd-lg-300">{{$t("express.运费规则")}}</th>
            <th class="wd-lg-300">{{$t("express.优惠方案")}}</th>
            <th class="wd-lg-200">{{$t("express.操作")}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in items" :key="index">
            <td class="valign-middle">
              <div class="tx-white">
              	<p class="mg-b-5" v-if="item.isAllProvince == 1">
              		<span>{{$t("express.全部省份")}}</span>
              	</p>
              	<p class="mg-b-5" v-if="item.isAllProvince == 2">
              		<span v-for="province in item.provinces">{{province}} / </span>
              	</p>
              </div>
            </td>
            <td class="valign-middle">
              <div class="tx-white">
              	<p class="mg-b-5">
              		{{item.ruleType == 1 ? $t('express.按单收运费') : ''}}
									{{item.ruleType == 2 ? $t('express.按重量收运费') : ''}}
									{{item.ruleType == 3 ? $t('express.按件收运费') : ''}}
              	</p>
              	<p class="mg-b-5" v-if="item.ruleType == '1'">
              		{{$t("express.每单")}}{{item.ruleJson.everyFee}}{{$t("express.元")}}
              	</p>
              	<p class="mg-b-5" v-if="item.ruleType == '2'">
              		<span class="mg-b-5 d-block">
              			{{$t("express.首重")}}{{item.ruleJson.startWeight}}{{$t("express.克，运费")}}{{item.ruleJson.startPrice}}{{$t("express.元，")}}
              		</span>
              		<span class="mg-b-5 d-block">
              			{{$t("express.每续重")}}{{item.ruleJson.incWeight}}{{$t("express.克，运费加")}}{{item.ruleJson.incPrice}}{{$t("express.元，")}}
              		</span>
              	</p>
								<p class="mg-b-5" v-if="item.ruleType == '3'">
									<span class="mg-b-5 d-block">
              			{{$t("express.首件，运费")}}{{item.ruleJson.startPrice}}{{$t("express.元，")}}
              		</span>
									<span class="mg-b-5 d-block">
              			{{$t("express.后续每件，运费")}}{{item.ruleJson.incPrice}}{{$t("express.元，")}}
              		</span>
								</p>

              </div>
            </td>
            <td class="valign-middle tx-14">
              <div class="tx-ellipsis2 mg-b-0 tx-white" v-if="item.discountStatus == 1">
              	<p class=" mg-b-5">
              		{{$t("express.货款满")}}{{item.priceFree | formatDate}}{{$t("express.元包邮")}}
              	</p>
              </div>
            </td>
            <td class="valign-middle tx-14">
              <div class="mg-b-0 tx-white">
              	<p class="mg-b-5">
              		<a href="javascript:;" class="tx-info" @click="openAddShippingfee(item)">{{$t("express.编辑")}}</a>
              	</p>
              	<p class="mg-b-5">
              		<a href="javascript:;" class="tx-info" @click="delAdd(index)">{{$t("express.删除")}}</a>
              	</p>
              	<p class="mg-b-5">
              		<a href="javascript:;" class="tx-info" @click="move(index,'1')">{{$t("express.上移")}}</a>
              	</p>
              	<p class="mg-b-5">
              		<a href="javascript:;" class="tx-info" @click="move(index,'2')">{{$t("express.下移")}}</a>
              	</p>
              </div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="4">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("express.没有符合条件的地址")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
    };
  },
  watch: {
  },
  filters: {
	    formatDate(val) {
	      if (!val) return "----";
	      return Number(val).toFixed(2);
	    }
	},
  updated() {
  },
  methods: {
  	move(i,type){
  		this.$emit("move",i,type);
  	},
  	openAddShippingfee(item){
  		this.$emit("openAddShippingfee",item);
  	},
  	delAdd(i){
  		this.$emit("delAdd",i);
  	},
  }
};
</script>


